/* Dispatch 13 -- Adaptive AppShell.
 *
 * Chooses between the preserved desktop chrome (DesktopShell) and the new
 * mobile chrome (MobileShell) based on viewport width. The two shells
 * share nothing but the same `<Outlet />` -- routes rendered underneath
 * do not need to be viewport-aware unless they explicitly want to.
 *
 * Existing consumers keep importing `AppShell` from
 * `@/components/shell/AppShell`; no callers changed.
 */
import React from "react";
import { useIsMobile } from "@/lib/viewport";
import { DesktopShell } from "./DesktopShell";
import { MobileShell } from "./MobileShell";
// D51 -- global persistent "Trip active · Tracking" banner. Rendered
// on both desktop + mobile shells so any screen the user visits during
// an active field trip surfaces the tracking indicator.
import TripActiveBanner from "@/components/TripActiveBanner";

export function AppShell() {
  const isMobile = useIsMobile();
  return (
    <>
      <TripActiveBanner />
      {isMobile ? <MobileShell /> : <DesktopShell />}
    </>
  );
}

export default AppShell;
